import { jsx as s, jsxs as E, Fragment as $ } from "react/jsx-runtime";
import P, { useState as a, useRef as L, useEffect as g, Suspense as A } from "react";
import { r as w } from "../../index-YbL9dKxh.mjs";
import { classes as k } from "../../utils/helpers.js";
import { blockLayoutsMap as F } from "../../settings.js";
import { X as K } from "../../x-D8_C2o-U.mjs";
import '../../assets/ModalContainer.css';const M = "_modal_1vlfz_1", y = {
  modal: M,
  "modal__close-btn": "_modal__close-btn_1vlfz_48"
}, N = (r) => {
  if (!document.querySelector(`#${r}`)) {
    const t = document.createElement("div");
    t.setAttribute("id", r), document.querySelector("body").append(t);
  }
};
function V({
  contentComponent: r = "BCVideoPlayer",
  airaLabel: h = "",
  modalId: t = "modal-container",
  onModalClose: x = () => !0,
  children: u
}) {
  const [p, B] = a(null), [D, _] = a("entering"), [v, C] = a(!1), [c, m] = a(null), [O, d] = a(!1), o = L(null), b = L(null), f = () => {
    _("exiting"), C(!0), o.current !== null && setTimeout(() => {
      o.current.close(), C(!1), _("entering"), x();
    }, 750);
  }, i = (e) => {
    [...o.current.attributes].findIndex((n) => n.name === "open") !== -1 && e.key === "Escape" && (e.preventDefault(), e.stopPropagation(), f());
  }, S = (e) => {
    e.target.classList.contains(`${y.modal}`) && f();
  };
  return N(t), g(() => {
    document.getElementById(t).removeEventListener(`scripps:${t.replaceAll("-", "")}:change`, (n) => {
      m(n.detail.componentProps), n.detail.forceOpen && d((l) => !l);
    });
    async function e() {
      B(F.get(r));
    }
    return r !== "" && e(), document.getElementById(t).addEventListener(`scripps:${t.replaceAll("-", "")}:change`, (n) => {
      m(n.detail.componentProps), n.detail.forceOpen && d((l) => !l);
    }), () => {
      document.getElementById(t).removeEventListener(`scripps:${t.replaceAll("-", "")}:change`, (n) => {
        m(n.detail.componentProps), n.detail.forceOpen && d((l) => !l);
      });
    };
  }, [r, t]), g(() => {
    let e = null;
    const n = () => {
      const l = setInterval(() => {
        o.current !== null && (clearInterval(l), e = o.current);
      }, 100);
    };
    return o.current === null && n(), () => {
      e == null || e.close();
    };
  }, [p]), g(() => {
    o.current !== null && [...o.current.attributes].findIndex((e) => e.name === "open") === -1 && c !== null && (o.current.showModal(), b.current.blur());
  }, [c, O]), w.createPortal(
    /* @__PURE__ */ s(A, { children: /* @__PURE__ */ E(
      "dialog",
      {
        ref: o,
        "data-state": D,
        className: k([y.modal, "modal"]),
        onKeyDown: i,
        onKeyUp: i,
        onClick: S,
        onCancel: (e) => e.preventDefault(),
        "aria-modal": "true",
        "aria-label": h,
        children: [
          p !== null && u === void 0 && /* @__PURE__ */ s(
            p,
            {
              ...c,
              containerClosing: v,
              handleClosing: i
            }
          ),
          u !== void 0 && /* @__PURE__ */ s($, { children: P.Children.map(u, (e) => P.cloneElement(e, {
            ...c,
            containerClosing: v,
            handleClosing: i
          })) }),
          /* @__PURE__ */ E(
            "button",
            {
              type: "button",
              onClick: f,
              className: k([y["modal__close-btn"], "modal__close-btn"]),
              "aria-label": "Close",
              ref: b,
              children: [
                /* @__PURE__ */ s("span", { className: "sr-only", children: "close" }),
                /* @__PURE__ */ s("i", { children: /* @__PURE__ */ s(K, { width: "48", height: "48" }) })
              ]
            }
          )
        ]
      }
    ) }),
    document.getElementById(t)
  );
}
export {
  V as ModalContainer,
  V as default
};
